export default __webpack_public_path__ + "476aa92e4f692ee1b5019fb10a6a94a8.svg";